
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.494 11.665a.588.588 0 11-.83.834.588.588 0 01.83-.834zm-4.159-3.33a.588.588 0 10-.829-.834.588.588 0 00.83.834zm9.077 2.477c.366.494.51 1.118.4 1.723a2.254 2.254 0 01-1.365 1.177 2.224 2.224 0 00-.718.435c-.114.261-.182.54-.2.824a2.23 2.23 0 01-.7 1.652c-.54.294-1.179.351-1.764.16a2.56 2.56 0 00-.86-.065 2.43 2.43 0 00-.587.535 2.28 2.28 0 01-1.618.982 2.284 2.284 0 01-1.57-.94 2.432 2.432 0 00-.618-.536 2.416 2.416 0 00-.86.064 2.239 2.239 0 01-1.764-.158 2.227 2.227 0 01-.717-1.677 2.42 2.42 0 00-.2-.823 2.225 2.225 0 00-.742-.436 2.254 2.254 0 01-1.364-1.176 2.222 2.222 0 01.4-1.724c.178-.249.306-.53.376-.829a2.357 2.357 0 00-.33-.812 2.222 2.222 0 01-.4-1.723A2.253 2.253 0 013.53 6.27c.265-.099.508-.246.718-.436a2.42 2.42 0 00.2-.823 2.23 2.23 0 01.724-1.653A2.239 2.239 0 016.935 3.2c.28.073.572.095.86.065a2.43 2.43 0 00.617-.536A2.28 2.28 0 0110 1.765c.632.08 1.201.422 1.57.94.166.21.364.391.589.536.287.03.579.008.859-.065a2.239 2.239 0 011.764.16 2.23 2.23 0 01.747 1.676c.018.284.086.562.2.823.217.192.469.34.742.436a2.254 2.254 0 011.364 1.176 2.222 2.222 0 01-.4 1.724 2.35 2.35 0 00-.376.829c.065.29.185.566.353.812zM6.67 9.17a1.765 1.765 0 102.492-2.502A1.765 1.765 0 006.67 9.171zm6.658-1.665a.59.59 0 10-.835-.835l-5.823 5.823a.59.59 0 10.835.835l5.823-5.823zm0 3.323a1.765 1.765 0 10-2.491 2.502 1.765 1.765 0 002.492-2.502z","fill":"#002823"}})])
          )
        }
      }
    